import { osName, browserName } from 'react-device-detect';

const DEVICE_ID_KEY = 'fs_device_id';

const generateUUID = () => {
	if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
		return crypto.randomUUID();
	}
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};

export const getDeviceId = () => {
	try {
		let id = localStorage.getItem(DEVICE_ID_KEY);
		if (!id) {
			id = generateUUID();
			localStorage.setItem(DEVICE_ID_KEY, id);
		}
		return id;
	} catch {
		return generateUUID();
	}
};

export const getDeviceName = () => {
	try {
		if (osName && browserName) return `${osName} · ${browserName}`;
		if (osName) return `${osName} Device`;
		if (browserName) return browserName;
		return 'Browser';
	} catch {
		return 'Browser';
	}
};
